{
  "$id": "module://alert-subscription-config",
  "$schema": "wealthlane://schemas/domain",
  "title": "Alert Subscription",
  "type": "object",
  "properties": {
    "sourceCompanyId": {
      "type": "string",
      "title": "Company",
      "widget": "select",
      "noBlank": true,
      "adapterProps": {
        "placeholder": "Select Company"
      }
    },
    "alertType": {
      "type": "string",
      "title": "Alert Type",
      "widget": "select",
      "noBlank": true
    },
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "email": {
      "type": "string",
      "title": "Email",
      "widget": "text",
      "noBlank": true,
      "format": "email"
    },
    "subscribedOn": {
      "type": "string",
      "title": "Subscribed On",
      "widget": "label",
      "adapterProps": {
        "hideLabel": true,
        "variant": "body-s"
      }
    }
  }
}
